import React, { useState } from 'react';
import { FormikProps } from 'formik';
import { CFormGroup, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel } from '@coreui/react';
import { get } from 'lodash';
import classNames from 'classnames';
import CIcon from '@coreui/icons-react';
import { UserPasswordPayload } from '../../shared/models/user';
import eye from '../../assets/images/eye.svg';
import eyeStricken from '../../assets/images/eye-stricken.svg';

export interface TechnicianFormProps {
  formik: FormikProps<UserPasswordPayload>;
  disabled?: boolean;
}

const ResetPasswordForm = ({ formik, disabled}: TechnicianFormProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  const isInvalidPasswordConfirmation = () => {
    return (formik.touched.password || formik.touched.passwordConfirm) && formik.errors.passwordConfirm;
  };

  return (
    <>
      <CFormGroup>
        <CLabel htmlFor="password">Password</CLabel>
        <CInputGroup>
          <CInput
            id="password"
            name="password"
            placeholder="Password"
            type={showPassword ? 'text' : 'password'}

            className={classNames({ 'is-invalid': isInvalid('password') })}
            disabled={disabled}
            {...formik.getFieldProps('password')}
          />
          <CInputGroupAppend>
            <CInputGroupText onClick={() => setShowPassword(!showPassword)} className="cursor-pointer">
              <CIcon src={showPassword ? eye : eyeStricken} className="password-eye"/>
            </CInputGroupText>
          </CInputGroupAppend>
          {isInvalid('password') && <div className="invalid-feedback">{formik.errors.password}</div>}
        </CInputGroup>
      </CFormGroup>
      <CFormGroup>
        <CLabel htmlFor="passwordConfirm">Confirm Password</CLabel>
        <CInputGroup>
          <CInput
            id="passwordConfirm"
            name="passwordConfirm"
            placeholder="Confirm Password"
            type={showConfirmPassword ? 'text' : 'password'}
            className={classNames({ 'is-invalid': isInvalidPasswordConfirmation() })}
            disabled={disabled}
            {...formik.getFieldProps('passwordConfirm')}
          />
          <CInputGroupAppend>
            <CInputGroupText onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="cursor-pointer">
              <CIcon src={showConfirmPassword ? eye : eyeStricken} className="password-eye"/>
            </CInputGroupText>
          </CInputGroupAppend>
          {isInvalidPasswordConfirmation() && <div className="invalid-feedback">{formik.errors.passwordConfirm}</div>}
        </CInputGroup>
      </CFormGroup>
    </>
  );
};

ResetPasswordForm.defaultProps = {
  disabled: false
};

export default ResetPasswordForm;
